import { useCallback, useState } from "react";
import useAdminLoad from "../../../hooks/useAdminLoad";
import * as crmApi from "../api/crmApi";

/**
 * The Performance zone for a period (`GET /api/crm/dashboard/performance`). `period` is
 * `{period, from?, to?}` and may be a fresh object each render: the read is keyed by its
 * serialisation, so the whole zone recalculates exactly when the selection changes.
 */
export default function usePerformance(period) {
  const key = JSON.stringify(period);
  const [data, setData] = useState(null);
  const load = useCallback(async () => { setData(await crmApi.getPerformance(JSON.parse(key))); }, [key]);
  const { loading, loadError, reload } = useAdminLoad(load);
  return { data, loading, loadError, reload };
}
